import React, { useEffect, useState } from 'react'
import { useFileDispatch } from '../context/FileContext';
import { api } from '../api/apis';

const SelectExampleAudioFile = () => {
  const [audioFile,,selectAudioFileHandler,,,,, resetStatisticsHandler] = useFileDispatch();
  const [selectedAudio, setSelectedAudio] = useState("");
  const [exampleAudioFiles, setExampleAudioFiles] = useState([]);

  const audioFileHandler = (event) => {
    selectAudioFileHandler(event.target.value);
    resetStatisticsHandler();
  }

  useEffect(() => {
    setSelectedAudio(audioFile);
  }, [audioFile]);

  useEffect(() => {
    api.get("/api/getExampleAudioFiles").then((res) => {
      setExampleAudioFiles(res.data);
    }).catch((error) => {
      // alert(error);
    });
  }, []);

  return (
    <div className=' flex flex-col'>
        <label htmlFor='audioFile' className="mb-5 block text-xl font-semibold text-[#07074D]">
          Select an example audio file from below
        </label>
        <select className=' bg-blue-600 text-white py-1 px-2 rounded-md' value={selectedAudio} onChange={audioFileHandler}>
            <option style={{display: "none"}}>Select Audio</option>
            <option value={""}>Select Audio</option>
            {exampleAudioFiles.map((file) => <option value={file}>{file}</option>)}
        </select>
    </div>
  )
}

export default SelectExampleAudioFile;